import {
  Component,
  inject,
  OnInit,
  ChangeDetectionStrategy,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { NgxGaugeModule } from 'ngx-gauge';

import { GaugeValueKPI } from '../../../types';

@Component({
  selector: 'app-gauge-value-modal',
  templateUrl: './gauge-value-modal.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatButtonModule, MatDialogModule, MatIconModule, NgxGaugeModule],
})
export class GaugeValueModalComponent implements OnInit {
  readonly dialogRef = inject(MatDialogRef<GaugeValueModalComponent>);

  readonly data: GaugeValueKPI = inject(MAT_DIALOG_DATA);

  thresholdConfig: Record<string, { color: string; bgOpacity?: number }>;

  markerConfig: Record<
    string,
    { color: string; size: number; type: string; label: string | number }
  >;

  ngOnInit(): void {
    this.thresholdConfig = {
      '0': { color: 'green', bgOpacity: 0.2 },
      [this.data.maxValue * 0.4]: { color: 'orange', bgOpacity: 0.2 },
      [this.data.maxValue * 0.755]: { color: 'red', bgOpacity: 0.2 },
    };

    this.markerConfig = {
      '0': { color: '#555', size: 8, label: '0', type: 'line' },
      [this.data.maxValue * 0.25]: {
        color: '#555',
        size: 8,
        label: `${Math.round(this.data.maxValue * 0.25)}`,
        type: 'line',
      },
      [this.data.maxValue * 0.5]: {
        color: '#555',
        size: 8,
        label: `${Math.round(this.data.maxValue * 0.5)}`,
        type: 'line',
      },
      [this.data.maxValue * 0.75]: {
        color: '#555',
        size: 8,
        label: `${Math.round(this.data.maxValue * 0.75)}`,
        type: 'line',
      },
      [this.data.maxValue]: {
        color: '#555',
        size: 8,
        label: `${Math.round(this.data.maxValue)}`,
        type: 'line',
      },
      [this.data.value]: {
        color: '#000',
        size: 10,
        label: `${Math.round(this.data.value)}`,
        type: 'triangle',
      },
    };
  }
}
